// Begin: Enums — API `featureName` / DB `account_feature.feature_name` (Java `AccountFeatureType`)
enum ACCOUNT_FEATURE {
  AI_INSIGHTS = "AI_INSIGHTS",
  PERSONAS = "PERSONAS",
  PROJECT_SEARCH = "PROJECT_SEARCH",
  ACCOUNT_SEARCH = "ACCOUNT_SEARCH",
}
export default ACCOUNT_FEATURE;
